/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "#/lib/social-signal-api-client.ts"
import type {
  RequestConfig,
  ResponseErrorConfig,
} from "#/lib/social-signal-api-client.ts"
import type {
  GetUserProfileQueryResponse,
  GetUserProfilePathParams,
  GetUserProfile401,
  GetUserProfile403,
  GetUserProfile404,
} from "../types/GetUserProfile.ts"
import { getUserProfileQueryResponseSchema } from "../zod/getUserProfileSchema.ts"

function getGetUserProfileUrl(id: GetUserProfilePathParams["id"]) {
  const res = { method: "GET", url: `/users/${id}/profile` as const }
  return res
}

/**
 * @summary Get the profile of a user you follow
 * {@link /users/:id/profile}
 */
export async function getUserProfile(
  id: GetUserProfilePathParams["id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetUserProfileQueryResponse,
    ResponseErrorConfig<
      GetUserProfile401 | GetUserProfile403 | GetUserProfile404
    >,
    unknown
  >({
    method: "GET",
    url: getGetUserProfileUrl(id).url.toString(),
    ...requestConfig,
  })
  return getUserProfileQueryResponseSchema.parse(res.data)
}
